<template>
  <div>
    <el-dialog title="历史报文下发任务列表" :visible.sync="TimingTaskRecording" :before-close="handclose_99" width="1100px" center style="z-index: 10000">
      <el-col v-if="typeSHow" :span="5">
        <div class="flex" style="margin: 10px">
          <div class="titii">任务名称：</div>
          <el-input v-model="searchFormTimingTaskRecording.taskName" placeholder="请输入内容"></el-input>
        </div>
      </el-col>
      <!-- <el-col v-if="typeSHow&&searchFormTimingTaskRecording.taskType!=0" :span="5">
        <div class="flex" style="margin:10px">
          <div class="titii">
            设备类型：
          </div>
          <el-select v-model="searchFormTimingTaskRecording.type" placeholder="请选择任务类型">
            <el-option label="光照强度" value="0"> </el-option>
            <el-option label="土壤湿度" value="1"> </el-option>
            <el-option label="Co2浓度" value="2"> </el-option>
            <el-option label="内风机" value="3"> </el-option>
            <el-option label="空气温度" value="4"> </el-option>
            <el-option label="空气湿度" value="5"> </el-option>
          </el-select>
        </div>
      </el-col> -->
      <el-col v-if="typeSHow" :span="8">
        <div class="flex" style="margin: 10px">
          <div class="titii">操作时间：</div>
          <el-date-picker v-model="searchFormTimingTaskRecording.time" type="datetimerange" :picker-options="pickerOptions" @change="getTime_1" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right"> </el-date-picker>
        </div>
      </el-col>
      <el-col v-if="typeSHow" :span="4" style="margin: 7px">
        <el-button type="primary" class="status_open a33" @click="getDataHisCmdTaskList"> 查询 </el-button>
        <el-button type="primary" class="status_open a33" @click="reasta13"> 重置 </el-button>
      </el-col>
      <div v-if="typeSHow" class="table_content1" style="margin-top: 10px">
        <el-table :data="TimingTaskRecordingtableData" align="center" class="data-table" style="width: 100%" v-loading="loading" :header-cell-style="{ background: '#F4F5F7' }">
          <el-table-column prop="taskName" align="center" label="任务名称"></el-table-column>
          <el-table-column align="center" label="任务状态" width>
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0">等待中</span>
              <span v-if="scope.row.status == 1">进行中</span>
              <span v-if="scope.row.status == 2">已完成</span>
              <span v-if="scope.row.status == 3">任务失败</span>
            </template>
          </el-table-column>
          <!-- <el-table-column align="center" label="设备类型" width>
            <template slot-scope="scope">
              <span v-if="scope.row.type == 0">光照强度</span>
              <span v-if="scope.row.type == 1">土壤湿度</span>
              <span v-if="scope.row.type == 2">Co2浓度</span>
              <span v-if="scope.row.type == 3">内风机</span>
              <span v-if="scope.row.type == 4">空气温度</span>
              <span v-if="scope.row.type == 5">空气湿度</span>
            </template>
          </el-table-column> -->
          <el-table-column align="center" label="任务时间" width>
            <template slot-scope="scope">
              <span>{{ scope.row.taskTime }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width>
            <template slot-scope="scope">
              <div class="open_button_ a235" @click="handleEdit(scope.row.id)">详情</div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-container">
          <div class="page"></div>
          <div class="pagination-content-container">
            <el-pagination background layout="prev, pager, next, jumper" class="pageTap" @current-change="handleCurrentChange_2" :current-page="searchFormTimingTaskRecording.pageNum" :page-size="searchFormTimingTaskRecording.pageSize" :total="searchFormTimingTaskRecording.total"></el-pagination>
          </div>
        </div>
      </div>
      <div v-if="!typeSHow" class="table_content1" style="margin-top: 10px">
        <div>
          <el-button style="margin-bottom: 20px" type="primary" @click="closeBack">返回</el-button>
          <el-button>任务数量：{{ status0 + status1 + status2 }}</el-button>
          <el-button type="success">成功：{{ status1 }}</el-button>
          <el-button type="danger">失败：{{ status2 }}</el-button>
          <el-button type="primary">下发中：{{ status0 }}</el-button>
        </div>
        <el-table height="450" :data="hiscmdList" align="center" class="data-table" style="width: 100%" v-loading="loading" :header-cell-style="{ background: '#F4F5F7' }">
          <el-table-column prop="name" align="center" label="报文名称"></el-table-column>
          <el-table-column align="center" label="报文内容">
            <template slot-scope="scope">
              <span>
                {{ scope.row.cmd }}
              </span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="下发状态" width>
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0">
                <i style="color: blue; font-size: 16px; font-weight: bold" class="el-icon-loading"></i>
              </span>
              <span v-if="scope.row.status == 1">
                <i style="color: green; font-size: 16px; font-weight: bold" class="el-icon-check"></i>
              </span>
              <span v-if="scope.row.status == 2">
                <i style="color: red; font-size: 16px; font-weight: bold" class="el-icon-close"></i>
              </span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="下发次数">
            <template slot-scope="scope">
              <span>
                {{ scope.row.cmdNum }}
              </span>
            </template>
          </el-table-column>
        </el-table>
        <div class="button">
          <el-button type="primary" @click="sendTask(0)">全部重新下发</el-button>
          <el-button type="primary" @click="sendTask(1)">仅下发失败</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      TimingTaskRecording: false,
      searchFormTimingTaskRecording: {
        pageNum: 1,
        pageSize: 10,
        total: 1,
        startTime: '',
        endTime: '',
        time: '',
        decisionId: '',
        deviceType: '',
        groupId: '',
        status: '',
        taskName: '',
        taskType: '',
        type: ''
      },
      TimingTaskRecordingtableData: [],
      hiscmdList: [],
      typeSHow: true,
      taskId: '',
      timer_lsit: '',
      status0: '',
      status1: '',
      status2: ''
    }
  },
  mounted() {},
  methods: {
    closeBack() {
      this.typeSHow = !this.typeSHow
      clearInterval(this.timer_lsit)
    },
    sendTask(type) {
      this.$api.growthModel.sendTask({ taskId: this.taskId, type: type }).then(res => {
        if (res.code == 200) {
          this.$message.success(res.msg)
        }
      })
    },
    handclose_99() {
      this.TimingTaskRecording = false
      clearInterval(this.timer_lsit)
      this.searchFormTimingTaskRecording = {
        pageNum: 1,
        pageSize: 10,
        total: 1,
        startTime: '',
        endTime: '',
        time: '',
        decisionId: '',
        deviceType: '',
        groupId: '',
        status: '',
        taskName: '',
        taskType: '',
        type: ''
      }
    },
    reasta13() {
      this.searchFormTimingTaskRecording.startTime = ''
      this.searchFormTimingTaskRecording.endTime = ''
      this.searchFormTimingTaskRecording.time = ''
      this.searchFormTimingTaskRecording.taskName = ''
      this.searchFormTimingTaskRecording.pageNum = 1
      this.getDataHisCmdTaskList()
    },
    openTimeTask_1(val) {
      this.TimingTaskRecording = true
      // this.searchFormTimingTaskRecording.id = this.value
      this.getDataHisCmdTaskList()
    },
    getDataHisCmdTaskList() {
      // this.searchFormTimingTaskRecording.type = this.activeName
      this.$api.growthModel.getDataHisCmdTaskList(this.searchFormTimingTaskRecording).then(res => {
        if (res.code == 200) {
          this.TimingTaskRecordingtableData = res.data
          this.searchFormTimingTaskRecording.total = res.count
        }
      })
    },
    handleCurrentChange_2(currentPage) {
      this.searchFormTimingTaskRecording.pageNum = currentPage
      this.getDataHisCmdTaskList()
    },
    getTime_1(val) {
      this.searchFormTimingTaskRecording.startTime = val[0]
      this.searchFormTimingTaskRecording.endTime = val[1]
      this.getDataHisCmdTaskList()
    },
    handleEdit(val) {
      this.typeSHow = !this.typeSHow
      this.taskId = val
      this.getlist()
      this.timer_lsit = setInterval(() => {
        this.getlist()
      }, 2000)
    },
    getlist(val) {
      this.$api.growthModel.getDataHisCmdTaskDetails({ id: this.taskId }).then(res => {
        if (res.code == 200) {
          this.status0 = 0
          this.status1 = 0
          this.status2 = 0
          res.data.map(item => {
            if (item.status == 0) {
              this.status0 = this.status0 + 1
            } else if (item.status == 1) {
              this.status1 = this.status1 + 1
            } else if (item.status == 2) {
              this.status2 = this.status2 + 1
            }
          })
          this.hiscmdList = res.data
        }
      })
    }
  }
}
</script>

<style scoped>
.open_button_ {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #256bff;
  line-height: 17px;
  font-style: normal;
  cursor: pointer;
  white-space: nowrap;
}
.button {
  margin: 20px;
  display: flex;
  justify-content: right;
}
.titii {
  white-space: nowrap;
}
.flex {
  display: flex;
  align-items: center;
}
</style>
